import { createFileRoute, Outlet } from '@tanstack/react-router'

import InnerApp from '../../containers/app/inner-app'
import { requireAuth } from '../utils/auth-guards'
import AuthBoundary from '../utils/auth-boundary'

const LoggedRoutesLayout = () => {
  const { auth } = Route.useRouteContext()

  return (
    <AuthBoundary auth={auth}>
      <InnerApp>
        <Outlet />
      </InnerApp>
    </AuthBoundary>
  )
}

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: requireAuth,
  component: LoggedRoutesLayout
})
